import React from 'react';
import { Form } from 'react-bootstrap';
import Button from '../UI/button'
import SvgIcon from '../SVG/svg'

export interface ThInputTextModel {
  label: string;
  labelShow?: boolean;
  value: string;
  placeholder?: string;
  required?: boolean;
  onChange?: (value: string) => void;
  mb?: number;
  mt?: number;
  search?: boolean;
  maxLength?: number;
}

function ThInputText({
  label,
  labelShow = true,
  value,
  placeholder = 'Enter here',
  required,
  onChange,
  mb = 24,
  mt = 0,
  search = false,
  maxLength
}: ThInputTextModel) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <Form.Group
      className='position-relative'
      style={{marginBottom: `${mb}px`, marginTop: `${mt}px`}}
      controlId={label.replace(/\s+/g, '')}
    >
      {labelShow && <Form.Label>
        {label} 
        {required && <span className='text-primary'>*</span>}
      </Form.Label>}
      <Form.Control
        maxLength={maxLength}
        type='text'
        placeholder={placeholder}
        required={required}
        defaultValue={value}
        onChange={handleChange}
      />
      {search &&  <Button variant='transparent' height='auto' className='p-0' style={{position: 'absolute', right: '15px', bottom: '17px'}}>
        <SvgIcon type='search' width={16} height={16} fill='#555555' />
      </Button>}
    </Form.Group>
  );
}

export default ThInputText;
